import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TimeagoModule } from "ngx-timeago";
import { DatePipe } from './pipes/date-pipe/date.pipe';
import { SideNavComponent } from './components/shared/layout/side-nav/side-nav.component';
import { HeaderComponent } from './components/shared/layout/header/header.component';
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { ToastrModule } from 'ngx-toastr';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SigninComponent } from './components/auth/signin/signin.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { TokenInterceptor } from './services/app/token-interceptor/token.interceptor';
import { SortByPipe } from './pipes/order-by/order-by.pipe';
import { CamelCasePipe } from './pipes/camelcase.filter/camelcase.filter.pipe';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';

import { ClockTimePipe } from './pipes/clock-time/clock-time.pipe';
import { FilterPipe } from './pipes/list-filter-pipe/list-filter-pipe';
import { CircleTimerModule } from "./libraries/circle-timer/src/lib/circle-timer.module";
import { MySocketWrapper } from './services/app/socket-service/socket-wrapper';
import { SocketService } from './services/app/socket-service/socket-service.service';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { GooglePlaceDirective } from './directives/google-places-directive/google-place.directive';
import { UsersListComponent } from './components/user/users-list/users-list.component';
import { AddUserComponent } from './components/user/add-user/add-user.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AddRoleComponent } from './components/role/add-role/add-role.component';
import { ListRoleComponent } from './components/role/list-role/list-role.component';
import { NotificationsComponent } from './components/shared/layout/notifications/notifications.component';
import { NotificationModalComponent } from './components/shared/layout/notification-modal/notification-modal.component';
import { TripCardComponent } from './components/shared/layout/trips/trip-card/trip-card.component';
import { OutsideClickDirective } from './directives/outside-click-directive/outside-click.directive';
import { TrimInputDirective } from './directives/trim-input-directive/trim-input.directive';
import { TripListingComponent } from './components/shared/layout/trips/trip-listing/trip-listing.component';
import { OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { PhoneNumberFormatterDirective } from './directives/phone-number-format-directive/phone-number-formatter.directive';
import { GoogleMapsInitializer } from './services/app/googlemap-key-service/google-maps-initializer.service';
import { ConvertPhoneNumberDirective } from './directives/number-directive/convert-phone-number.directive';
import { VoiceNavigationComponent } from './components/shared/voice-navigation/voice-navigation.component';
import { QuickbooksListComponent } from './components/quickbooks/quickbooks-list/quickbooks-list.component';
import { AddQuickbooksComponent } from './components/quickbooks/add-quickbooks/add-quickbooks.component';
import { QuickbooksConnectedComponent } from './components/quickbooks/quickbooks-connected/quickbooks-connected.component';
import { EmployeeListComponent } from './components/employee/employee-list/employee-list.component';
import { AddEmployeeComponent } from './components/employee/add-employee/add-employee.component';
import { CustomersListComponent } from './components/customers/customers-list/customers-list.component';
import { AddCustomerComponent } from './components/customers/add-customer/add-customer.component';
import { CompaniesListComponent } from './components/companies/companies-list/companies-list.component';
import { AddCompanyComponent } from './components/companies/add-company/add-company.component';
import { CustomerDetailModalComponent } from './components/modals/customer-detail-modal/customer-detail-modal.component';
import { EmployeeDetailModalComponent } from './components/modals/employee-detail-modal/employee-detail-modal.component';
import { CompanyDetailModalComponent } from './components/modals/company-detail-modal/company-detail-modal.component';
import { InvoiceListComponent } from './components/Invoices/invoice-list/invoice-list.component';
import { AddInvoiceComponent } from './components/Invoices/add-invoice/add-invoice.component';
import { ActionDropdownButtonsComponent } from './components/shared/dropdowns/action-dropdown-buttons/action-dropdown-buttons.component';
import { AddProductServiceComponent } from './components/product-services/add-product-service/add-product-service.component';
import { ProductServiceListComponent } from './components/product-services/product-service-list/product-service-list.component';
import { InvoiceDetailModalComponent } from './components/modals/invoice-detail-modal/invoice-detail-modal.component';
import { ServiceDetailModalComponent } from './components/modals/service-detail-modal/service-detail-modal.component';
import { VendorsListComponent } from './components/vendors/vendors-list/vendors-list.component';
import { AddVendorComponent } from './components/vendors/add-vendor/add-vendor.component';
import { VendorDetailModalComponent } from './components/modals/vendor-detail-modal/vendor-detail-modal.component';
import { BillListComponent } from './components/bills/bill-list/bill-list.component';
import { AddBillComponent } from './components/bills/add-bill/add-bill.component';
import { PayBillComponent } from './components/bills/pay-bill/pay-bill.component';
import { ReceivePaymentComponent } from './components/Invoices/receive-payment/receive-payment.component';
import { BillPaymentListComponent } from './components/bills/bill-payment-list/bill-payment-list.component';
import { InvoicePaymentListComponent } from './components/Invoices/invoice-payment-list/invoice-payment-list.component';
import { BillDetailModalComponent } from './components/modals/bill-detail-modal/bill-detail-modal.component';


export const MY_MOMENT_FORMATS = {
  fullPickerInput: 'MM/DD/YYYY HHmm',
  parseInput: 'l LT',
  datePickerInput: 'l',
  timePickerInput: 'HH:mm',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  bgsOpacity: 0.5,
  bgsPosition: 'bottom-right',
  bgsSize: 80,
  bgsType: 'ball-spin-clockwise',
  blur: 0,
  fgsColor: '#727cf5',
  fgsPosition: 'center-center',
  fgsSize: 0,
  fgsType: 'ball-spin',
  gap: 24,
  logoPosition: 'center-center',
  logoSize: 150,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: '#ffffff00',
  pbColor: '#727cf5',
  pbDirection: 'ltr',
  pbThickness: 3,
  hasProgressBar: true,
  text: '',
  textColor: '#FFFFFF',
  textPosition: 'center-center',
};

@NgModule({
  declarations: [
    AppComponent,
    SideNavComponent,
    HeaderComponent,
    SigninComponent,
    ResetPasswordComponent,
    SortByPipe,
    CamelCasePipe,
    ClockTimePipe,
    FilterPipe,
    DatePipe,
    GooglePlaceDirective,
    UsersListComponent,
    AddUserComponent,
    ProfileComponent,
    AddRoleComponent,
    ListRoleComponent,
    NotificationsComponent,
    NotificationModalComponent,
    TripCardComponent,
    OutsideClickDirective,
    TrimInputDirective,
    TripListingComponent,
    PhoneNumberFormatterDirective,
    ConvertPhoneNumberDirective,
    VoiceNavigationComponent,
    QuickbooksListComponent,
    AddQuickbooksComponent,
    QuickbooksConnectedComponent,
    EmployeeListComponent,
    AddEmployeeComponent,
    CustomersListComponent,
    AddCustomerComponent,
    CompaniesListComponent,
    AddCompanyComponent,
    CompanyDetailModalComponent,
    CustomerDetailModalComponent,
    EmployeeDetailModalComponent,
    InvoiceListComponent,
    AddInvoiceComponent,
    ActionDropdownButtonsComponent,
    AddProductServiceComponent,
    ProductServiceListComponent,
    InvoiceDetailModalComponent,
    ServiceDetailModalComponent,
    VendorsListComponent,
    AddVendorComponent,
    VendorDetailModalComponent,
    BillListComponent,
    AddBillComponent,
    PayBillComponent,
    ReceivePaymentComponent,
    BillPaymentListComponent,
    InvoicePaymentListComponent,
    BillDetailModalComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPaginationModule,
    TimeagoModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig), // import NgxUiLoaderModule
    NgxUiLoaderHttpModule.forRoot({
        exclude: ['http://provider.qalbs.com/api/assigns/dashboard', 'http://provider.qalbs.com/api/notifications', 'http://provider.qalbs.com/api/assigns/corporate',
            'http://provider.qalbs.com/api/users/me', 'http://provider.qalbs.com/api/drivers/nearby'],
        showForeground: true
    }),
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-bottom-left',
        preventDuplicates: true,
        progressBar: true
    }),
    NgMultiSelectDropDownModule.forRoot(),
    GoogleMapsModule,
    NgSelectModule,
    CircleTimerModule,
    CommonModule,
    

],
  // providers: [
  //   { provide: UnAuthorizationGuard, useClass: UnAuthorizationGuard },
  // ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (initializer: GoogleMapsInitializer) => () => initializer.initialize(),
      deps: [GoogleMapsInitializer],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    // { provide: AuthorizationGuard, useClass: AuthorizationGuard },
    // { provide: UnAuthorizationGuard, useClass: UnAuthorizationGuard },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { useUtc: false } },

    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    // },
    DatePipe,
    MySocketWrapper,
    SocketService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



